(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../_util/date", "../_util/raf", "./utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../_util/date"), require("../_util/raf"), require("./utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.date, global.raf, global.utils);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _date, _raf, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-count-down"
      }, [_vm.$scopedSlots.default ? [_vm._t("default", null, {
        "timeData": _vm.padZeroTime
      })] : _c('span', {
        attrs: {
          "aria-label": _vm.millisecond ? '' : _vm.ariaLabelFormattedTime
        }
      }, [_vm._v(_vm._s(_vm.formattedTime))])], 2);
    },
    name: 'nx-countdown',
    props: {
      millisecond: Boolean,
      time: {
        type: Number,
        default: 0
      },
      format: {
        type: String,
        default: 'HH:mm:ss'
      },
      autoStart: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {
        remain: 0
      };
    },
    computed: {
      timeData: function timeData() {
        return (0, _utils.parseTimeData)(this.remain);
      },
      formattedTime: function formattedTime() {
        return (0, _utils.parseFormat)(this.format, this.timeData);
      },
      ariaLabelFormattedTime: function ariaLabelFormattedTime() {
        return (0, _utils.ariaParseFormat)(this.format, this.timeData);
      },
      padZeroTime: function padZeroTime() {
        var _this = this;

        var padZeroObj = {};
        Object.keys(this.timeData).forEach(function (key) {
          if (key === 'milliseconds') {
            padZeroObj[key] = (0, _date.padZero)(_this.timeData[key], 3);
          } else {
            padZeroObj[key] = (0, _date.padZero)(_this.timeData[key]);
          }
        });
        return padZeroObj;
      }
    },
    watch: {
      time: {
        immediate: true,
        handler: 'reset'
      }
    },
    activated: function activated() {
      if (this.keepAlivePaused) {
        this.counting = true;
        this.keepAlivePaused = false;
        this.tick();
      }
    },
    deactivated: function deactivated() {
      if (this.counting) {
        this.pause();
        this.keepAlivePaused = true;
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.pause();
    },
    methods: {
      start: function start() {
        if (this.counting) {
          return;
        }

        this.counting = true;
        this.endTime = Date.now() + this.remain;
        this.tick();
      },
      pause: function pause() {
        this.counting = false;
        (0, _raf.cancelRaf)(this.rafId);
      },
      reset: function reset() {
        this.pause();
        this.remain = this.time;

        if (this.autoStart) {
          this.start();
        }
      },
      tick: function tick() {
        if (this.millisecond) {
          this.microTick();
        } else {
          this.macroTick();
        }
      },
      microTick: function microTick() {
        var _this2 = this;

        this.rafId = (0, _raf.raf)(function () {
          _this2.setRemain(_this2.getRemain());

          if (_this2.remain !== 0) {
            _this2.microTick();
          }
        });
      },
      macroTick: function macroTick() {
        var _this3 = this;

        this.rafId = (0, _raf.raf)(function () {
          var remain = _this3.getRemain();

          if (!(0, _utils.isSameSecond)(remain, _this3.remain) || remain === 0) {
            _this3.setRemain(remain);
          }

          if (_this3.remain !== 0) {
            _this3.macroTick();
          }
        });
      },
      getRemain: function getRemain() {
        return Math.max(this.endTime - Date.now(), 0);
      },
      setRemain: function setRemain(remain) {
        this.remain = remain;
        this.$emit('change', this.timeData);

        if (remain === 0) {
          this.pause();
          this.$emit('finish');
        }
      }
    }
  };
  _exports.default = _default;
});